import "core-js/modules/es.array.reduce.js";
import CategoriesApi from '@/frontend/api/categories';
import WorksApi from '@/frontend/api/works';
import WorksFilterComponent from "@/frontend/components/WorksFilterComponent";
import WorkCardComponent from "@/frontend/components/WorkCardComponent";
import setMetas from '@/frontend/functions/setMetas';
export default {
  name: "CategoryPage",
  components: {
    WorksFilterComponent,
    WorkCardComponent
  },

  data() {
    return {
      Category: {},
      works: [],
      PaginationLinks: {},
      PaginationMeta: {
        currentPage: 1,
        pageCount: 1
      },
      search: '',
      workRequestParams: {}
    };
  },

  watch: {
    search() {
      this.changePage(1);
    }

  },
  methods: {
    requestWorks() {
      this.workRequestParams['filter[or][][name][like]'] = this.search;
      this.workRequestParams['filter[or][][authorName][like]'] = this.search;
      WorksApi.get(this.workRequestParams).then(response => {
        this.works = response.items;
        this.works.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
      });
    },

    filterWorks(authorIds = [], years = []) {
      this.workRequestParams['filter[year][in]'] = years;
      this.workRequestParams['filter[authorId][in]'] = authorIds;
      WorksApi.get(this.workRequestParams).then(response => {
        this.works = response.items;
        this.works.forEach(value => {
          value.price = value.characteristics.reduce((old, next) => !old && next.name === 'Информация' ? next.name + ': ' + next.value : old, '');
        });
        this.PaginationLinks = response._links;
        this.PaginationMeta = response._meta;
      });
    },

    changePage(number) {
      if (number < 1 || this.PaginationMeta.pageCount && number > this.PaginationMeta.pageCount) return;
      this.PaginationMeta.currentPage = number;
      this.workRequestParams.page = number;
      this.requestWorks();
      window.scrollTo(0, 0);
    }

  },

  created() {
    setMetas('category');
    this.workRequestParams = {
      'per-page': 21,
      page: this.PaginationMeta.currentPage,
      'filter[categoryId]': this.$route.params.id,
      expand: ['author', 'categories'].join(',')
    };
    this.requestWorks();
    CategoriesApi.get({
      fields: ['id', 'name']
    }, this.$route.params.id).then(response => this.Category = response);
  }

};